import Chip, { IChipProps } from '@srm/ui/chip';
import clsx from 'clsx';

import './DictChipItem.scss';

export interface IDictChipItemProps extends Omit<IChipProps, 'children' | 'onRemove' | 'onClick'> {
    /** Значение */
    item?: string;
    /** Показывать иконку удаления
     * @default true
     */
    showRemoveIcon?: boolean;
    /** Функция удаления элемента */
    onRemove?: (item: string) => Promise<void>;
    /** Функция клика по элементу */
    onClick?: () => void;
    /** Класс */
    className?: string;
}

const DictChipItem = ({ item, showRemoveIcon = true, onRemove, onClick, className, ...props }: IDictChipItemProps) => {
    if (!item) {
        return null;
    }

    return (
        <div className={clsx('rf-dictchipitem', className)}>
            <Chip
                size="sm"
                variant="outline"
                maxLength={30}
                tooltipBackground={'white'}
                onRemove={showRemoveIcon ? async () => await onRemove?.(item) : undefined}
                onClick={onClick}
                iconPosition="right"
                {...props}
            >
                {item}
            </Chip>
        </div>
    );
};

export default DictChipItem;
